import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { StoreCustomersLoyaltyComponent } from './store-customers-loyalty/store-customers-loyalty.component';
import { StoreCustomersKpiComponent } from './store-customers-kpi/store-customers-kpi.component';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {ApiMethods, PermissionConfiguration} from '../../../models/permission.model';
import {PermsService} from '../../../services/utils/perms.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-store-customers',
  templateUrl: './store-customers.component.html',
  styleUrls: ['./store-customers.component.css']
})
// Pagina 29 & MORE
export class StoreCustomersComponent implements OnInit {
    @ViewChild(StoreCustomersLoyaltyComponent) customersLoyalty: StoreCustomersLoyaltyComponent;
    @ViewChild(StoreCustomersKpiComponent) customersKpi: StoreCustomersKpiComponent;
    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

    items: MenuItem[];
    activeIndex: number;
    oldData: any;


  /********************** PERMESSI UTENTE *************************/

  // Abilita tab Principali KPI
  public negoziClientiMainPerm: boolean;
  public negoziClientiMainPermCheck: PermissionConfiguration;

  // Abilita tab Loyalty e Contattabilità
  public negoziClientiLoyaltyPerm: boolean;
  public negoziClientiLoyaltyPermCheck: PermissionConfiguration;

  /****************************************************************/


    constructor(private translate: TranslateService,
                private svcAnalytics: AnalyticsService,
                private srvPerms: PermsService,
                private searchModelFactory: SearchToolbarModelFactoryService) {
      this.negoziClientiMainPermCheck = {
        ms_base: 'koncentro-analytics',
        operation: 'negozi-clienti-main',
        method: ApiMethods.GET
      };
      this.negoziClientiLoyaltyPermCheck = {
        ms_base: 'koncentro-analytics',
        operation: 'negozi-clienti-loyalty',
        method: ApiMethods.GET
      };
    }

    ngOnInit() {
      this.activeIndex = 0;
      this.items = [];

      Observable.zip(
        this.srvPerms.check(this.negoziClientiMainPermCheck),
        this.srvPerms.check(this.negoziClientiLoyaltyPermCheck)
      ).subscribe(([negoziClientiMain, negoziClientiLoyalty] ) => {
        console.log('PERMISSION');
        this.negoziClientiMainPerm = negoziClientiMain;
        this.negoziClientiLoyaltyPerm = negoziClientiLoyalty;


        this.translate.get([
          // 'store.customers_tab_overview_title',
          'store.customersTabKpiTitle',
          'store.customers_tab_loyalty_title',
          // 'store.customers_tab_value_title',
          // 'store.customers_tab_models_title'
        ]).subscribe(t => {
          const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
          searchParams.svcAnalytics = this.svcAnalytics;
          searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
          searchParams.finestra = SearchToolbarFilterWindow.TwentyNine;
          // searchParams.dateFunctionType = SearchToolbarDateFunction.CsDates;
          // searchParams.finestra = SearchToolbarFilterWindow.Month;
          searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
          searchParams.disabledSections = [SearchToolbarSection.CardModes];

          this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
            this.searchModel = model;
          });
          this.items.push(
            /*{
              label: t['store.customers_tab_overview_title'],
              command: (event: any) => {
                this.activeIndex = 0;
              }
            },*/
            {
              label: t['store.customersTabKpiTitle'],
              command: (event: any) => {
                this.activeIndex = 0;
              }, disabled: !this.negoziClientiMainPerm
            },
            {
              label: t['store.customers_tab_loyalty_title'],
              command: (event: any) => {
                this.activeIndex = 1;
              }, disabled: !this.negoziClientiLoyaltyPerm
            },
            /*{
              label: t['store.customers_tab_value_title'],
              command: (event: any) => {
                this.activeIndex = 2;
              }
            },
            {

              label: t['store.customers_tab_models_title'],
              command: (event: any) => {
                this.activeIndex = 3;
              }
            }*/
          );

          for (let index in this.items) {
            if (!this.items[index].disabled) {
              this.activeIndex = +index;
              break;
            }
          }
        });
      });
    }

    ApplyResult (data) {
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.customersLoyalty.resetData();
                }
                this.customersKpi.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.customersKpi.resetData();
                }

                this.customersLoyalty.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }


}



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers.component.ts